module.exports = __webpack_public_path__ + "static/media/gryphon_musee_northvanarts_3.d900bf4c.jpg";